class NavigationItem extends HTMLElement {

    #isOpen = false;
    #expandedClassName = 'subnav-expanded';

    constructor() {
        super();
        this.trigger = this.querySelector('.js-navigation-mobile-expander');
    }

    connectedCallback() {
        this.setupTriggerClickListeners();
        this.setupOpenSubNavigationListener();
    }

    /**
     * Listens to clicks on expander; toggles subnavigation on click
     */
    setupTriggerClickListeners() {
        // If menu has no subnavigation, there will be no trigger. No need to add open/close
        // functionality.
        // On desktop, the trigger exists but is not visible – will be initialized, but clicks
        // are not possible.
        if (!this.trigger) return;
        this.trigger.addEventListener('click', this.toggleSubNav.bind(this));
    }

    /**
     * Closes current subnavigation when opensubnavigation is fired on window *and* if it was
     * not fired by current navigation element.
     */
    setupOpenSubNavigationListener() {
        window.addEventListener('opensubnavigation', (ev) => {
            if (ev.target === this) return;
            this.closeSubnavigation();
        });
    }

    toggleSubNav() {
        if (this.#isOpen) this.closeSubnavigation();
        else this.openSubnavigation();
    }

    closeSubnavigation() {
        this.#isOpen = false;
        requestAnimationFrame(() => this.classList.remove(this.#expandedClassName));
    }

    /**
     * On close, emit an opensubnavigation event that causes all other open NavigationEntries to
     * close themselves
     */
    openSubnavigation() {
        this.#isOpen = true;
        this.dispatchEvent(new CustomEvent('opensubnavigation', { bubbles: true }));
        requestAnimationFrame(() => this.classList.add(this.#expandedClassName));
    }

}

if (!window.customElements.get('navigation-item')) {
    window.customElements.define('navigation-item', NavigationItem);
}
